import React, { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import stars from "../../images/stars.svg";
import primaryarrow from "../../images/primary-arrow.svg";
import { httpApi } from "api/http.api";
import AdvanceCandidateSummary from "components/HRFlow/steps/Step4Candidates/AdvanceCandidateSummary";

const { Paragraph } = Typography;

interface CandidateBioComponentProps {
  id?: number;
  isHRFlow?: boolean;
  bio?: string | string[] | null;
  hideBioAndArrow?: boolean;
  searchType?: string | null;
}

const CandidateBioComponentNew: React.FC<CandidateBioComponentProps> = ({ id, bio, isHRFlow, hideBioAndArrow, searchType }) => {
  const [view, setView] = useState<"bio" | "ai">("bio");
  const [bioData, setBioData] = useState<string[]>([]);
  const [aiSummary, setAiSummary] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [readMore, setReadMore] = useState<boolean>(false);

  const getAiSummary = async () => {
    setView("ai");
  };


  useEffect(() => {
    if (!bio) return;

    try {
      const parsed = typeof bio === "string" ? JSON.parse(bio) : bio;
      setBioData(Array.isArray(parsed) ? parsed : [parsed.bio || parsed]);
    } catch {
      setBioData(Array.isArray(bio) ? bio : [bio]);
    }
  }, [bio]);

  return (
    <div className={`mt-5 ${isHRFlow ? "" : "border-t border-main-border"} w-full`}>
      {/* Tabs */}
      <div className={`flex gap-4 mt-2 px-1.5 py-2 ${isHRFlow ? "" : "border-b border-dashed"}`}>
        {!hideBioAndArrow && (
          <p
            onClick={() => setView("bio")}
            className={`text-sm font-bold cursor-pointer ${
              view === "bio" ? "text-primary" : "text-text-heading"
            }`}
          >
            Bio
          </p>
        )}
        <p
          {...(!hideBioAndArrow ? { onClick: getAiSummary } : {})}
          className={`text-sm font-medium flex gap-1 cursor-pointer w-[100%] 
    ${isHRFlow && !hideBioAndArrow ? "border-l border-main-border px-[13px]" : ""} 
    ${view === "ai" ? "text-primary" : "text-text-heading "}`}
        >
          <img src={stars} alt="star" />
          AI Summary
          {/* {view === "ai" ? "Hide AI Summary" : "View AI Summary"} */}
          {/* {!hideBioAndArrow && <img src={primaryarrow} alt="arrow" />} */}
        </p>
      </div>

      {/* Content */}
      <Spin spinning={loading} size="small" className="min-h-10">
        {view === "bio" && (
          <div className={`mt-1 p-5 ${isHRFlow ? "bg-bg-primary" : ""}`}>
            {bioData.length > 0 ? (
              <Paragraph
                className="text-text-secondary text-sm font-normal"
                ellipsis={{
                  rows: 2,
                  expandable: true,
                  symbol: "Read more",
                }}
                style={{
                  marginBottom: 0,
                }}
              >
                {bioData.join(" ")}
              </Paragraph>
            ) : (
              <p className="text-text-secondary">No bio available.</p>
            )}
          </div>
        )}

        {view === "ai" && (
          <div className="bg-bg-primary">
            <AdvanceCandidateSummary id={id} />
          </div>
        )}
      </Spin>
    </div>
  );
};

export default CandidateBioComponentNew;
